<div style=" background-image: url('/assets/images/puppycorner.jpg'); background-position: 50% 10%; height: 450px; background-size: cover;">
  </div>
  <div class="div-block-6">
    <div>
      <div class="row">
        <div class="col-1"></div>
      <div class="col-2" text-center>
        <div class="blocks pulse" (click)="gotoSearchByLifestage(5)">
          <h3 class="heading-block pulse">Food</h3>
        </div>
      </div>
      <div  class="col-3" text-center>
        <div class="blocks pulse" (click)="gotoSearchByLifestage(6)">
          <h3 class="heading-block pulse">Treats</h3>
        </div>
      </div>


      <div  class="col-3" text-center>
        <div class="blocks pulse" (click)="gotoSearchByLifestage(7)">
          <h3 class="heading-block pulse">Supplies</h3>
        </div>
      </div>

      <div  class="col-2" text-center>
        <div class="blocks pulse" routerLink="/blogs/category">
          <h3 class="heading-block pulse">Articles</h3>
        </div>
      </div>
      <div class="col-1"></div>
    </div>
    </div>
    
  </div>

  <div  class="col-12" text-center>
      <div  >
        <h3 class="heading-block pulse"> Have any Query related to your new Puppy? 
          Write to us at info@petcart.com.  
          Our Team of Experts will get back to you.</h3>
      </div>
    </div>
